import { render } from "./DomainForm.vue?vue&type=template&id=2f2359c4&scoped=true"
import script from "./DomainForm.vue?vue&type=script&lang=js"
export * from "./DomainForm.vue?vue&type=script&lang=js"

import "./DomainForm.vue?vue&type=style&index=0&id=2f2359c4&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2359c4"]])

export default __exports__